// Universal themes (light, dark) are always available to every org. Any
// other theme is partner-only — visible to an org only when it's that
// org's themeOverride or it's listed in org.config.availableThemes.
export const themes = [
    { name: 'light',    title: 'Light' },
    { name: 'dark',     title: 'Dark' },
    { name: 'opn',      title: 'OPN' },
    { name: 'regenimo', title: 'Regenimo' },
];

const UNIVERSAL = themes.map((k) => k.name);

export function getTheme(name) {
    if (! themes.find((e) => e.name === name )) {
        name = themes[0].name;          // default to the first theme if an invalid theme is provided...
    }
    const data = require(`./${name}`);
    return data.default;
}

// Returns the subset of themes the given org is allowed to see in the
// Settings picker. The org's themeOverride (when set) is always included
// so the default theme is reachable in the picker.
//
// If org.config.availableThemes is set (comma-separated list like
// "light,regenimo") — return those themes in the order authored.
// Otherwise default to the universal themes plus the org's themeOverride.
export function getThemes(org) {
    const orgThemeOverride = org?.config?.themeOverride || null;
    const availableThemes = org?.config?.availableThemes;
    const allowed = (availableThemes && typeof availableThemes === 'string')
        ? availableThemes.split(',').map((n) => n.trim()).filter(Boolean)
        : [...UNIVERSAL];
    if (orgThemeOverride && !allowed.includes(orgThemeOverride)) {
        allowed.push(orgThemeOverride);
    }
    return allowed.map((name) => themes.find((t) => t.name === name)).filter(Boolean);
}
